import { useSnapshot } from 'valtio';
import { tasksState } from '../state';
import { ITask } from '../types';

function useTasks() {
  const { tasks } = useSnapshot(tasksState);
  return {
    tasks: Object.values(tasks) as ITask[],
  };
}

export default useTasks;
